module.exports = __webpack_public_path__ + "img/popularize-icon3-07.e8b0ed95.png";